import {createSelector} from 'reselect'
import getDomainSettings from 'jsonFetches/getDomainSettings'



export const getCompanyName = () => {
  return (getDomainSettings()[window.location.hostname].mainSortName)

}
  
export const getTopLevelDomainName = () =>
  (getDomainSettings()[window.location.hostname].mainWebsiteUrl)

export const getTld = createSelector(
  [getTopLevelDomainName],
  (companyName) =>
    (getDomainSettings()[window.location.hostname].lang)
)

export const getTldLocale = createSelector(
  [getTopLevelDomainName],
  (companyName) =>
    (getDomainSettings()[window.location.hostname].langCode)
)

export const getTldEmail = createSelector(
  [getTopLevelDomainName],
  (companyName) =>
    (getDomainSettings()[window.location.hostname].mainEmail)
)
